var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex_column_evenly pair"},[_vm._m(0),_c('el-button',{staticClass:"pair_button",on:{"click":_vm.handleRecorderClick}},[_c('span',{attrs:{"lang":"Pair"}},[_vm._v("配对")])])],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex_row_center"},[_c('i',{staticClass:"incfont el-icon-title"}),_c('span',{staticClass:"margin_left",attrs:{"lang":"PairTool"}},[_vm._v("配对工具")])])
}]

export { render, staticRenderFns }